export const NAV = {
  home: "nav-home",
  about: "nav-about",
  services: "nav-services",
  leasing: "nav-leasing",
  sales: "nav-sales",
  contact: "nav-contact",
  downloads: "nav-downloads",
  bookAppointment: "nav-book-appointment",
  mobileMenuToggle: "nav-mobile-menu-toggle",
};

export const HOME = {
  heroBookBtn: "home-hero-book-btn",
  heroLeasingBtn: "home-hero-leasing-btn",
  ctaBookBtn: "home-cta-book-btn",
};

export const PROPERTY = {
  card: (id) => `property-card-${id}`,
  cardEnquire: (id) => `property-card-enquire-${id}`,
  detailEnquireBtn: "property-detail-enquire-btn",
  enquireSubmit: "property-enquire-submit",
  enquireName: "property-enquire-name",
  enquireEmail: "property-enquire-email",
  enquirePhone: "property-enquire-phone",
  enquireMessage: "property-enquire-message",
  filterListingType: "property-filter-listing-type",
  filterCity: "property-filter-city",
  filterNsfas: "property-filter-nsfas",
  clearFilters: "property-filter-clear",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  message: "contact-message",
  submit: "contact-submit",
};

export const APPOINTMENT = {
  name: "appt-name",
  email: "appt-email",
  phone: "appt-phone",
  company: "appt-company",
  date: "appt-date",
  timeSlot: "appt-time-slot",
  topic: "appt-topic",
  notes: "appt-notes",
  submit: "appt-submit",
};

export const DOWNLOADS = {
  brochurePdf: "download-brochure-pdf",
  logoPrimary: "download-logo-primary",
  logoDark: "download-logo-dark",
  logoLight: "download-logo-light",
  logoMono: "download-logo-mono",
  logoIcon: "download-logo-icon",
};
